import React from "react";
import { Col, Form, Input, Row, Select } from "antd";
import DragAndDrop from "./drag-and-drop";
import { IformField } from "../../stores/quotesStore";

const { Option } = Select;

export interface FormFieldProps {
  fields: IformField[];
}

const FormField: React.FC<FormFieldProps> = (props) => {
  const { fields } = props;

  const validationMsg = (field: IformField) => {
    if(field.name && field?.name.length > 15) {
      return "This feild is required"
    } else {
      return `Please ${field.type === "dropdown" ? 'select' : 'input'} ${field.name?.toLowerCase()}`
    }
  }

  const renderField = (field: IformField, i: number) => {
    return (
      <Col
        md={field.type === "drag_drop" ? 24 : 12}
        sm={field.type === "drag_drop" ? 24 : 12}
        xs={24}
        className="mb-1"
        key={i}
      >
        <span className="font-semibold">{field.name}</span>
        <Form.Item
          name={field.id}
          rules={[{
            required: field.type !== "drag_drop",
            message: validationMsg(field)
          }]}
        >
          <>
            {field.type === "dropdown" && (
              <Select
                placeholder={field.placeholder}
                allowClear
                className="my-2"
              >
                {field.options?.map((option, index) => (
                  <Option value={index} key={index}>
                    {option}
                  </Option>
                ))}
              </Select>
            )}
            {field.type === "drag_drop" && <DragAndDrop />}
            {field.type === "text" && (
              <Input placeholder={field.placeholder} className="my-2" />
            )}
            {field.type === "number" && (
              <Input
                type="number"
                placeholder={field.placeholder}
                className="my-2"
              />
            )}
          </>
        </Form.Item>
      </Col>
    );
  };

  return (
    <Row gutter={16} className="mt-4">
      {fields.map((field, index) => renderField(field, index))}
    </Row>
  );
};

export default FormField;
